import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import NationalTaxServiceCredentialsForm from '../../forms/NationalTaxServiceCredentialsForm';

const CompactVersion = ({ source }) => {
  const { t } = useTranslation();

  return (
    <Stack
      spacing={{ mobile: 2 }}
      alignItems="center"
      px={{ mobile: 2 }}
      mt={{ mobile: 1 }}
      width={{ mobile: '100%' }}
      sx={{
        height: '100%',
        my: 'auto',
      }}
      justifyContent="center"
    >
      <Box>
        <Typography
          color="black"
          fontSize={{ mobile: 13 }}
          fontWeight={500}
          textAlign={{ mobile: 'center' }}
          mb={{ mobile: 0.5 }}
        >
          Para acceder a financiamiento de facturas y a los productos de Fingo
        </Typography>
        <Typography
          color="primary"
          fontSize={{ mobile: 15 }}
          textAlign="center"
          fontWeight={600}
        >
          Ingresa tus credenciales del {t('National Tax Service acronym')}
        </Typography>
      </Box>
      <Box
        sx={{
          maxWidth: {
            mobile: '100%',
            tablet: '50%',
            desktop: '30%',
          },
        }}
      >
        <NationalTaxServiceCredentialsForm autocomplete source={source} />
      </Box>
    </Stack>
  );
};

CompactVersion.propTypes = {
  source: PropTypes.string,
};

CompactVersion.defaultProps = {
  source: null,
};

export default CompactVersion;
